module.exports = __webpack_public_path__ + "img/cf.f5e33c7f.svg";